<div class="container space-y-6">

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (loading) {
    <div class="my-6"><app-loading size="large" /></div>
  }

  @if (!loading && skuInfo) {

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div class="space-y-4">
        <div class="rounded border border-neutral-300 dark:border-neutral-700 p-3">
          <div class="font-semibold mb-2">Informações do SKU</div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div>
              <div>SkuID</div>
              <div class="font-medium">{{ skuInfo.id }}</div>
            </div>
            <div>
              <div>Nome do SKU</div>
              <div class="font-medium">{{ skuInfo.name }}</div>
            </div>
            <div>
              <div>RefID</div>
              <div class="font-medium">{{ skuInfo.refId || '-' }}</div>
            </div>
            <div>
              <div>É kit?</div>
              <div class="font-medium">{{ skuInfo.isKit || '-' }}</div>
            </div>
            <div>
              <div>Está ativo?</div>
              <div class="font-medium">{{ skuInfo.isActive ? 'Sim' : 'Não' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-y-4">
        <app-image-carousel [images]="getSkuImages()" [interval]="5000"></app-image-carousel>
      </div>
      <div class="space-y-4">
        <app-accordion [multiple]="false">
          <app-accordion-item icon="dollar-sign" label="Preços" bodyClass="rounded border border-neutral-300 dark:border-neutral-700 p-3" id="skuPrices">
            @if (skuInfo.pricing) {
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                <div>
                  <div>Preço de custo</div>
                  <div class="font-medium">{{ skuInfo.pricing.costPrice | currency:'BRL':'symbol' }}</div>
                </div>

                <div>
                  <div>Preço base</div>
                  <div class="font-medium">{{ skuInfo.pricing.basePrice | currency:'BRL':'symbol' }}</div>
                </div>

                <div>
                  <div>Preço de listagem</div>
                  <div class="font-medium">{{ skuInfo.pricing.listPrice | currency:'BRL':'symbol' }}</div>
                </div>

                <div>
                  <div>Markup</div>
                  <div class="font-medium">{{ skuInfo.pricing.markup }}</div>
                </div>
              </div>

              <table class="w-full text-sm mt-2">
                <thead class="bg-neutral-50 dark:bg-neutral-800">
                <tr>
                  <th class="text-left p-2">Canal</th>
                  <th class="text-left p-2">Preço</th>
                  <th class="text-left p-2">Markup</th>
                </tr>
                </thead>
                <tbody>
                  @for (row of (skuInfo.pricing.fixedPrices ?? []); track row.tradePolicyId) {
                    <tr class="border-t border-neutral-200 dark:border-neutral-700">
                      <td class="p-2">{{ row.tradePolicyId }}</td>
                      <td class="p-2 font-semibold">{{ row.value | currency:'BRL':'symbol' }}</td>
                      <td class="p-2">
                        @if (row.value && skuInfo.pricing.costPrice) {
                          {{ -(1 - row.value / skuInfo.pricing.costPrice) * 100 | number: '1.1-2' }} %
                        }
                      </td>
                    </tr>
                  } @empty {
                    <tr class="border-t border-neutral-200 dark:border-neutral-700">
                      <td colspan="3">
                        <p class="my-2 text-center">Nenhum preço encontrado para este SKU.</p>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p class="my-2 text-center">Nenhum preço encontrado para este SKU.</p>
            }
          </app-accordion-item>
        </app-accordion>
      </div>
    </div>
  }
</div>
